import { appStore } from "entities/App";
import { RailSearchRequestFunc } from "entities/RailSearchCard";
import { useSearchQuery, UseSearchQueryReturnType } from "entities/RailSearchCard";
import { subscriptionStore } from "entities/Subscription";

type UseRailSearchReturnType = {
  railSearchRequest: RailSearchRequestFunc;
  railSearchResponse: UseSearchQueryReturnType["searchResponse"];
  isRailSearchLoading: boolean;
  isRailSearchSuccess: boolean;
  isRailSearchError: boolean;
};

export const useRailSearch = ({ isAuthenticated }: { isAuthenticated: boolean }): UseRailSearchReturnType => {
  const { searchRequest, searchResponse, isSearchSuccess, isSearchError, isSearchLoading } = useSearchQuery({
    isAuthenticated,
    setSubscription: (subscription) => ({
      type: subscriptionStore.actions.setSubscription.type,
      payload: subscription,
    }),
    setActivePaymentModal: (activePaymentModal) => ({
      type: subscriptionStore.actions.setActivePaymentModal.type,
      payload: activePaymentModal,
    }),
    setAppIntegrationRequestLimitReached: (appIntegrationRequestLimitReached) => ({
      type: appStore.actions.setAppIntegrationRequestLimitReached.type,
      payload: appIntegrationRequestLimitReached,
    }),
    setWebAppRequestLimitReached: (webAppRequestLimitReached) => ({
      type: appStore.actions.setWebAppRequestLimitReached.type,
      payload: webAppRequestLimitReached,
    }),
  });

  return {
    railSearchRequest: searchRequest,
    railSearchResponse: searchResponse,
    isRailSearchLoading: isSearchLoading,
    isRailSearchSuccess: isSearchSuccess,
    isRailSearchError: isSearchError,
  };
};
